import { createFileRoute } from '@tanstack/react-router'

import { RepeatCardUsageScreen } from './-components/repeat-card-usage-screen.tsx'

export const Route = createFileRoute(
  '/transaction-monitoring/repeat-card-usage'
)({
  component: RepeatCardUsageScreen
})
